import React from 'react';
import { useNavigate } from 'react-router-dom';
import logoImage from '../assets/images/logonewnobg.png';
import '../styles/PrivacyPolicy.css';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  const handleBackToLogin = () => {
    navigate('/login');
  };

  return (
    <div className="privacy-container">
      <div className="privacy-content">
        {/* Header */}
        <div className="privacy-header">
          <div className="privacy-logo">
            <img src={logoImage} alt="VReels Shop" className="privacy-logo-img" />
          </div>
          <h1 className="privacy-title">Privacy Policy</h1>
          <p className="privacy-subtitle">Effective Date: October, 2025</p>
        </div>

        {/* Privacy Policy Content */}
        <div className="privacy-body">
          <section className="privacy-section">
            <h2 className="section-title">1. Introduction</h2>
            <p className="section-content">
              We at Vreels Shop value your privacy. This Privacy Policy explains how we collect, use, store, and protect your personal data when you use our platform.
            </p>
          </section>

          <section className="privacy-section">
            <h2 className="section-title">2. Data We Collect</h2>
            <ul className="section-list">
              <li><strong>From Buyers:</strong> Name, email, phone, billing/shipping addresses, payment details.</li>
              <li><strong>From Vendors:</strong> Business name, registration details, tax info, bank details, product listings.</li>
              <li><strong>Automatically:</strong> IP address, device information, browsing behavior (cookies, analytics).</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2 className="section-title">3. How We Use Your Data</h2>
            <ul className="section-list">
              <li>To process orders and payments.</li>
              <li>To provide customer support and resolve disputes.</li>
              <li>To verify Vendor identity and prevent fraud.</li>
              <li>To improve platform features, offers, and marketing.</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2 className="section-title">4. Sharing of Data</h2>
            <ul className="section-list">
              <li>With Vendors (to fulfill buyer orders).</li>
              <li>With payment providers (to process transactions).</li>
              <li>With service providers (IT, shipping, fraud detection).</li>
              <li>When required by law or regulatory authorities.</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2 className="section-title">5. Cookies & Tracking</h2>
            <p className="section-content">
              We use cookies to improve user experience, analyze site traffic, and deliver personalized ads.
            </p>
          </section>

          <section className="privacy-section">
            <h2 className="section-title">6. Data Retention</h2>
            <p className="section-content">
              We retain your data as long as your account is active or required for compliance.
            </p>
          </section>

          <section className="privacy-section">
            <h2 className="section-title">7. Data Security</h2>
            <p className="section-content">
              We use encryption, access controls, and secure servers. However, no method of transmission over the internet is 100% secure.
            </p>
          </section>

          <section className="privacy-section">
            <h2 className="section-title">8. Your Rights</h2>
            <ul className="section-list">
              <li>Access, update, or delete your personal data.</li>
              <li>Opt-out of marketing communications.</li>
              <li>Request data portability (where legally required).</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2 className="section-title">9. Children's Privacy</h2>
            <p className="section-content">
              Our platform is not intended for users under 13 years of age.
            </p>
          </section>

          <section className="privacy-section">
            <h2 className="section-title">10. Contact Us</h2>
            <p className="section-content">
              If you have questions about this Privacy Policy:
            </p>
            <ul className="section-list">
              <li><strong>Email:</strong> support@vreels.com</li>
              <li><strong>Address:</strong>Maha Naga Kali Services Pvt Ltd., DBA Vreels, Madhaphur, Hyderabad, Telangana, India</li>
            </ul>
          </section>
        </div>

        {/* Footer */}
        {/* <div className="privacy-footer">
          <button onClick={handleBackToLogin} className="btn btn-primary back-to-login-btn">
            Back to Login
          </button>
        </div> */}
      </div>
    </div>
  );
};

export default PrivacyPolicy;
